export default __webpack_public_path__ + "static/1591-18571873f44cdcd2a5cf321856f1befa.gif";